
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Delegate } from "@/script/apps/inspect/entity/InspectEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { DelegateService } from "@/script/apps/inspect/service/DelegateService";
import { ElMessage } from "element-plus";
import {
  createInspectContext,
  InspectService,
} from "@/script/apps/inspect/service/InspectService";
import { QueryParam } from "@/script/core/service/DataService";
import { DelegateSubService } from "@/script/apps/inspect/service/DelegateSubService";

@Options({})
export default class DelegateDetail extends BaseDetail {
  private service = new DelegateService();
  private insStatusCode = "all";
  private certStatusCode = "all";
  private payStatusCode = "all";

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_ins_delegate",
      "/ins/delegate",
      "/ins/delegate",
      this.service
    );
    data.entity = {
      user: { realName: "" },
      inspect: { code: "", name: "" },
    };
    data.statesName = "ins-delegate-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入委托单号", trigger: "blur" }],
    name: [{ required: true, message: "请输入委托单名称", trigger: "blur" }],
    username: [
      { required: false, message: "请输入客户账号用户名", trigger: "blur" },
    ],
    password: [
      { required: false, message: "请输入客户账号密码", trigger: "blur" },
    ],
  };

  protected initOptions() {
    super.initOptions();
    this.insStatusCode = "all";
    this.certStatusCode = "all";
    this.payStatusCode = "all";
  }

  public newEntity() {
    const inspectId = Number(this.$route.query.inspectId);
    const entity: Delegate = {
      inspectId,
      state: "0",
      accountType: "1",
      inspect: { code: "", name: "" },
    };

    const inspectContext = createInspectContext();
    inspectContext.service.loadEntity(
      inspectContext.serviceData.loadApiName,
      { id: inspectId },
      (data: any) => {
        const delegate = this.entity as Delegate;
        delegate.inspect = data;
      }
    );
    return entity;
  }

  public afterLoad() {
    const delegate = this.entity as Delegate;
    this.injectDetailData(delegate.delegateSubList!, []);
    this.generateRowNo();
  }

  private querySubList() {
    const delegate = this.entity as Delegate;
    const query = new QueryParam();
    const queryEntity = {
      mainId: delegate.id,
      insStatusCode: this.insStatusCode,
      certStatusCode: this.certStatusCode,
      payStatusCode: this.payStatusCode,
    };
    query.entity = queryEntity;
    new DelegateSubService().loadList(
      query,
      (data: any) => {
        delegate.delegateSubList = data.list;
        this.injectDetailData(delegate.delegateSubList!, []);
        this.generateRowNo();
      },
      function (error: Error) {
        ElMessage.error("加载列表失败，失败原因：" + error.message);
      },
      "/api/ins/delegate/sub/list/query"
    );
  }

  private changeAccountType() {
    const delegate = this.entity as Delegate;
    if (delegate.accountType === "1") {
      this.rules.username[0].required = false;
      this.rules.password[0].required = false;
    } else {
      this.rules.username[0].required = true;
      this.rules.password[0].required = true;
    }
  }

  download(scope: any) {}
}
